const CARD_ITEMS = [
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20celebrity%20gossip%20magazine%20cover%20design%2C%20soft%20coral%20pink%20and%20cream%20gradients%2C%20abstract%20geometric%20composition%20with%20speech%20bubbles%2C%20modern%20magazine%20layout%20style&width=800&height=500&seq=card-img-01&orientation=landscape',
    title: '深度解析：2026上半年娱乐圈十大名场面全复盘',
    tag: '深度',
    tagColor: 'bg-primary-500',
    desc: '从年初的离婚大戏到最近的综艺名场面，我们为你梳理了今年上半年最值得回味的十个吃瓜瞬间，每个都有详细背景和后续发展。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Soft%20warm%20abstract%20illustration%20of%20film%20industry%20news%2C%20peach%20and%20golden%20gradient%20background%2C%20minimalist%20movie%20related%20shapes%2C%20clean%20editorial%20magazine%20design&width=800&height=500&seq=card-img-02&orientation=landscape',
    title: '年末盘点：今年最受争议的五部影视作品全梳理',
    tag: '盘点',
    tagColor: 'bg-accent-500',
    desc: '口碑两极分化的热门影视作品大盘点，从评分、讨论度到幕后故事，一文看尽今年的争议之作。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Stylized%20warm%20toned%20illustration%20of%20music%20industry%20scene%2C%20soft%20rose%20and%20cream%20gradients%2C%20abstract%20musical%20elements%2C%20modern%20editorial%20design%2C%20clean%20composition&width=800&height=500&seq=card-img-03&orientation=landscape',
    title: '独家调查：顶流歌手合约纠纷背后的资本博弈',
    tag: '独家',
    tagColor: 'bg-primary-500',
    desc: '近期闹得沸沸扬扬的歌手合约事件，我们深入调查了背后的资本运作和利益纠葛，为你还原事情的来龙去脉。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20illustration%20of%20variety%20show%20behind%20the%20scenes%2C%20soft%20coral%20and%20gold%20tones%2C%20abstract%20stage%20lighting%20elements%2C%20modern%20editorial%20style&width=800&height=500&seq=card-img-04&orientation=landscape',
    title: '综艺内幕：一线制作人匿名爆料行业潜规则',
    tag: '爆料',
    tagColor: 'bg-accent-500',
    desc: '从业十五年的综艺制作人首次匿名接受采访，揭露了选角、剪辑、营销等环节中不为人知的行业内幕。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20illustration%20of%20fashion%20red%20carpet%20event%2C%20soft%20peach%20and%20cream%20gradients%2C%20elegant%20geometric%20composition%2C%20editorial%20magazine%20aesthetic&width=800&height=500&seq=card-img-05&orientation=landscape',
    title: '红毯图鉴：今年各大颁奖礼最佳与最差着装评选',
    tag: '时尚',
    tagColor: 'bg-secondary-500',
    desc: '汇总全年重要颁奖礼的红毯造型，从专业时尚角度点评明星们的穿搭选择，选出最惊艳和最翻车的Looks。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20soft%20abstract%20illustration%20of%20social%20media%20gossip%20scene%2C%20rose%20and%20golden%20gradient%20background%2C%20minimalist%20bubble%20shapes%2C%20clean%20editorial%20design&width=800&height=500&seq=card-img-06&orientation=landscape',
    title: '关系图谱：某当红女星复杂朋友圈人物关系全解析',
    tag: '吃瓜',
    tagColor: 'bg-primary-500',
    desc: '一张图看懂某女星错综复杂的朋友圈，从闺蜜到前任，从合作伙伴到竞争对手，关系网比电视剧还精彩。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20illustration%20of%20entertainment%20industry%20trends%2C%20soft%20coral%20and%20cream%20colors%2C%20abstract%20rising%20graph%20shapes%2C%20modern%20editorial%20magazine%20style&width=800&height=500&seq=card-img-07&orientation=landscape',
    title: '2026趋势预测：下半年哪些明星将成为话题制造机',
    tag: '预测',
    tagColor: 'bg-accent-500',
    desc: '基于上半年数据和行业动态，我们预测了未来六个月最有可能成为流量中心的明星，以及他们背后的原因分析。',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            精选长文
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">深度图文</h2>
          <p className="text-sm text-foreground-500 mt-2">不止吃瓜，更有深度的娱乐观察与独家报道</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CARD_ITEMS.slice(0, 6).map((item, i) => (
            <div key={i} className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer">
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                  }}
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`px-2 py-0.5 rounded text-xs font-medium text-background-50 ${item.tagColor}`}>{item.tag}</span>
                </div>
                <h3 className="font-heading text-base text-foreground-900 mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-5">
          <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer">
            <div className="flex flex-col sm:flex-row">
              <div className="sm:w-80 shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden">
                <img
                  src={CARD_ITEMS[6].img}
                  alt={CARD_ITEMS[6].title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                  }}
                />
              </div>
              <div className="flex-1 p-5 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`px-2 py-0.5 rounded text-xs font-medium text-background-50 ${CARD_ITEMS[6].tagColor}`}>{CARD_ITEMS[6].tag}</span>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-2">{CARD_ITEMS[6].title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{CARD_ITEMS[6].desc}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}